<template>
  <Modal>
    <Modal.Title>Your plan details</Modal.Title>
    <Modal.Body>
      <PlanDetailsBody :prices="prices" />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'

import type { BillingPrice } from '@/shared/graphql/legacy/generated'
import PlanDetailsBody from './PlanDetailsBody.vue'

defineProps<{
  prices: BillingPrice[]
}>()
</script>
